import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileAudioRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.2 5.4h5.5V10c0 2 1.6 3.7 3.6 3.7h4.3v12.2q0 .7-.8.8H10.2a1 1 0 0 1-.8-.9V6.4q0-.8.8-.9m7.9 1 4.5 4.7h-3.3q-1.1 0-1.2-1.2zM10 3A3 3 0 0 0 7 6.3v19.5c0 1.7 1.4 3.2 3.2 3.2h12.6c1.8 0 3.2-1.5 3.2-3.2V12.5q0-1.4-1-2.3l-6-6.3Q18 3 16.8 3zM18 16.6a1 1 0 0 0 .5 1.3q1.6.8 1.6 2.6-.1 1.8-1.6 2.6a1 1 0 0 0-.5 1.3q.4 1 1.3.5a5 5 0 0 0 2.7-4.4q0-3.1-2.7-4.4a1 1 0 0 0-1.3.5M12 18.5q-1 0-1.1 1.2v1.6q.1 1.2 1.1 1.3h.8l1.4 1.7q.2.3.6.3.8-.1.8-.8v-6.5q0-.8-.8-.8-.4 0-.6.3l-1.4 1.7zm6 3.4q.7-.4.8-1.4 0-1-.9-1.4-.6-.1-.7.6v1.6q.1.9.7.6" })
});
export default SvgFileAudioRegularIcon;
